import { authProvider, ISecurity } from '../../services/Security';
import { AzureAD, AuthenticationState } from 'react-aad-msal';

import React, { createContext, useContext } from 'react';


const Context = createContext<ISecurity>({
    authenticationState: AuthenticationState.Unauthenticated,
    login: authProvider.login,
    logout: authProvider.logout,
    getAccessToken: undefined
});

export function useSecurity() {
    return useContext(Context);
};


export function SecureContext({ children }) {

    const app =

        <AzureAD provider={authProvider}>
            {({ login, logout, authenticationState, error, accountInfo }) => {

                return (<Context.Provider value={{
                    login, logout,
                    authenticationState,
                    accountInfo
                }}>
                    {children}
                </Context.Provider>)
            }}
        </AzureAD>

    return (app)
}

